import TrunkTypes from 'pages/ga/trunkTypes/Index';
import TrunkTypesAdd from 'pages/ga/trunkTypes/Add';
import TrunkTypesEdit from 'pages/ga/trunkTypes/Edit';

const TrunkTypesRoutes = [
    { index: true, element: <TrunkTypes /> },
    { path: 'add', element: <TrunkTypesAdd /> },
    { path: 'edit/:id', element: <TrunkTypesEdit /> },
];

export default TrunkTypesRoutes;
